import { Route, RouteObject } from "react-router-dom";
import DisconnectionLandingPage from "./components/landing/landing";
import { CreateDisconnectionRequest } from "./components";
import ConfigurableReceipt from "../shared/components/ConfigurableReciept";
import DisconnectionReceipt from "./components/receipt/receipt";
import DisconnectionRequestDetailPage from "./components/details/details";
import DisconnectionSuccessPage from "./components/receipt/receipt";
import DisconnectLanding from "./components/create/landing";
import BulkDisconnectLanding from "./components/details/bulkDisconnect/landing/landing";

export interface disconnectionRoute extends Omit<RouteObject, "children"> {
  auth?: boolean;
  children?: disconnectionRoute[];
}

export const disconnectionRoutes: disconnectionRoute[] = [
  {
    path: "cx/disconnections",
    element: <DisconnectionLandingPage />,
  },
  {
    path: "cx/disconnections/create",
    element: <DisconnectLanding />,
  },
  {
    path: "cx/disconnections/create/:step",
    element: <DisconnectLanding />,
  },
  {
    path: "cx/disconnections/create/:consumerId/:consumerNo",
    element: <DisconnectLanding />,
  },
  {
    path: "cx/disconnections/create/:consumerId/:consumerNo/:step",
    element: <DisconnectLanding />,
  },

  {
    path: "cx/disconnections/receipt",
    element: <DisconnectionReceipt />,
  },
  {
    path: "cx/disconnections/view/:action/:id",
    element: <DisconnectionRequestDetailPage />,
  },
  {
    path: "cx/disconnections/bulk/view/:action/:id",
    element: <BulkDisconnectLanding />,
  },
  {
    path: "cx/disconnections/success",
    element: <DisconnectionSuccessPage />,
  },
];
